"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CirrusContext = void 0;
const react_1 = require("react");
exports.CirrusContext = react_1.createContext({
    socket: null,
    host: '',
    setHost: () => {
        throw new Error('CirrusContext.setHost called without SocketProvider');
    },
    clear: () => {
        throw new Error('CirrusContext.signOut called without SocketProvider');
    },
});
//# sourceMappingURL=CirrusContext.js.map